import { bsc, bscTestnet, polygon, polygonMumbai } from '@wagmi/core/chains'
import { eNetworkName } from "../contract/contract.config"
import { type Chain } from 'viem'

export enum eProviders {
    magic = 'magic',
    walletconnect = 'walletconnect'
}

export enum eStatus {
    notinit = 'notinit',
    pending = 'pending',
    success = 'success',
    failed = 'failed'
}

export const networkName = {
    1: "Main",
    2: "Morden",
    3: "Ropsten",
    4: "rinkeby",
    42: "Kovan",
    56: "bsc",
    97: "chapel",//testnet
    80001: "mumbai",
    137: 'polygon',
    80002: "amoy"
}

export interface iStatus {
    status: eStatus, value: any
}

export interface InetworkSettings {
    chainId: string
    chainName: string
    nativeCurrency: {
        name: string
        symbol: string
        decimals: number
    }
    rpcUrls: string[]
    blockExplorerUrls: string[]
}

export const networkSettings: { [name in eNetworkName]: InetworkSettings } = {
    bsc: {
        chainId: '0x38',
        chainName: 'Smart Chain',
        nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18
        },
        rpcUrls: [/* 'https://bsc-dataseed.binance.org/' */'https://rpc.ankr.com/bsc'],
        blockExplorerUrls: ['https://bscscan.com']
    },
    // rinkeby: undefined,
    chapel: {
        chainId: '0x61',
        chainName: 'Smart Chain - Testnet',
        nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18
        },
        rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
        blockExplorerUrls: ['https://testnet.bscscan.com']
    },
    mumbai: {
        chainId: '0x13881',
        chainName: 'Polygon Mumbai',
        nativeCurrency: {
            name: 'MATIC',
            symbol: 'MATIC',
            decimals: 18
        },
        rpcUrls: ['https://rpc.ankr.com/polygon_mumbai/'/* 'https://rpc-mumbai.maticvigil.com/' *//* 'https://polygon-mumbai.infura.io/v3/4458cf4d1689497b9a38b1d6bbf05e78' *//* 'https://rpc.ankr.com/polygon_mumbai' */],
        blockExplorerUrls: ['https://mumbai.polygonscan.com/']
    },
    polygon: {
        chainId: '0x89',
        chainName: 'Polygon',
        nativeCurrency: {
            name: 'MATIC',
            symbol: 'MATIC',
            decimals: 18
        },
        rpcUrls: ['https://polygon-rpc.com/'],
        blockExplorerUrls: ['https://polygonscan.com/']
    },
    amoy: {
        chainId: '0x13882',
        chainName: 'Amoy',
        nativeCurrency: {
            name: 'MATIC',
            symbol: 'MATIC',
            decimals: 18
        },
        rpcUrls: ['https://rpc-amoy.polygon.technology/'],
        blockExplorerUrls: ['https://amoy.polygonscan.com/']
    }
}



// export const _bsc = {
//     id: 56,
//     name: "BNB Smart Chain",
//     network: "bsc",
//     nativeCurrency: {
//         decimals: 18,
//         name: "BNB",
//         symbol: "BNB",
//     },
//     rpcUrls: {
//         default: {
//             http: ["https://bsc-dataseed.binance.org/"],
//         },
//         public: {
//             http: ["https://bsc-dataseed.binance.org/"],
//         },
//     },
//     blockExplorers: {
//         etherscan: {
//             name: "BscScan",
//             url: "https://bscscan.com",
//         },
//         default: {
//             name: "BscScan",
//             url: "https://bscscan.com",
//         },
//     },
//     contracts: {
//         multicall3: {
//             address: "0xca11bde05977b3631167028862be2a173976ca11",
//             blockCreated: 15921452,
//         },
//     },
// }

const amoy: Chain = {
    id: 80002,
    name: "Amoy",
    network: "Polygon Amoy Testnet",
    nativeCurrency: {
        decimals: 18,
        name: "MATIC",
        symbol: "MATIC",
    },
    rpcUrls: {
        default: {
            http: ["https://rpc-amoy.polygon.technology/"],
        },
        public: {
            http: ["https://rpc-amoy.polygon.technology/"],
        },
    },
    blockExplorers: {
        etherscan: {
            name: "AmoyScan",
            url: "https://amoy.polygonscan.com",
        },
        default: {
            name: "AmoyScan",
            url: "https://amoy.polygonscan.com",
        },
    },
    // contracts: {
    //     multicall3: {
    //         address: "0xca11bde05977b3631167028862be2a173976ca11",
    //         blockCreated: 15921452,
    //     },
    // },
}

export const wagmiNetwork: { [networkName in eNetworkName]: any } = {
    bsc: bsc,
    chapel: bscTestnet,
    // rinkeby: null,
    mumbai: polygonMumbai,
    polygon: polygon,
    amoy: amoy
}